import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { UserContext, UserContextType } from './context/UserContext';
import AppRoutes from './routes/AppRoutes';

interface AppProps {
  respId: string | null;
  userId: string | null;
  userName: string | null;
  sessionId: string | null;
}

const App = ({ respId, userId, userName, sessionId }: AppProps) => {
  // Store in sessionStorage
  sessionStorage.setItem('user', userId || '');
  sessionStorage.setItem('username', userName || '');
  sessionStorage.setItem('sessionId', sessionId || '');
  sessionStorage.setItem('respId', respId || '');

  // Create user context
  const [userState] = useState<UserContextType>({
    userId: userId || '',
    userName: userName || '',
    responsibilityId: respId || '',
    sessionId: sessionId || ''
  });

  return (
    <BrowserRouter>
      <UserContext.Provider value={userState}>
        <AppRoutes />
      </UserContext.Provider>
    </BrowserRouter>
  );
};

export default App;
